import { render, staticRenderFns } from "./ProfilePlane.vue?vue&type=template&id=0dcdfefe&scoped=true&"
import script from "./ProfilePlane.vue?vue&type=script&lang=js&"
export * from "./ProfilePlane.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePlane.vue?vue&type=style&index=0&id=0dcdfefe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcdfefe",
  null
  
)

export default component.exports